import { Flex } from 'antd';
import { WEBSITE_PUBLIC_CDN } from 'util/constants';
import ProductsButton from '@src/components/ui-kit/buttons/ProductsButton';
import { openNewTab } from 'util/helpers';
import styles from './agent-sections.module.css';

export default function UseCasesSection() {
  return (
    <Flex
      vertical
      gap={48}
      align='center'
      justify='center'
      className={styles.useCasesSectionRoot}
      data-cy='agent3d-testimonials'
    >
      <h1 className={styles.useCasesSectionTitle}>USE CASES:</h1>
      <Flex vertical gap={20} align='center' justify='center'>
        <Flex
          gap={20}
          align='center'
          justify='center'
          className={styles.useCasesSectionContent}
        >
          <Flex vertical gap={20} className={styles.useCaseSmallImageContainer}>
            <img
              src={`${WEBSITE_PUBLIC_CDN}/hr-training-image.png`}
              className={styles.useCaseSmallImage}
              alt='HR'
            />
            <Flex
              vertical
              gap={12}
              align='start'
              justify='center'
              className={styles.useCaseTextWrapper}
            >
              <span className={styles.useCaseSmallImageTitle}>HR training</span>
              <span className={styles.useCaseSmallImageDescription}>
                Use interactive 3D AI avatars to onboard your team.{`        `}
              </span>
            </Flex>
          </Flex>
          <Flex
            vertical
            gap={20}
            align='center'
            justify='center'
            className={styles.useCaseSmallImageContainer}
          >
            <img
              src={`${WEBSITE_PUBLIC_CDN}/sales-and-marketing.png`}
              className={styles.useCaseSmallImage}
              alt='Sales and Marketing'
            />
            <Flex
              vertical
              gap={12}
              align='start'
              justify='center'
              className={styles.useCaseTextWrapper}
            >
              <span className={styles.useCaseSmallImageTitle}>
                SALES and MARKETING
              </span>
              <span className={styles.useCaseSmallImageDescription}>
                Embedd your custom trained AI AVATAR on your website to help
                drive sales and help convert your visitors much better than a
                traditional bot
              </span>
            </Flex>
          </Flex>
        </Flex>

        <Flex
          gap={20}
          align='center'
          justify='center'
          className={styles.useCasesSectionContent}
        >
          <Flex
            vertical
            gap={20}
            align='center'
            justify='center'
            className={styles.useCaseSmallImageContainer}
          >
            <img
              src={`${WEBSITE_PUBLIC_CDN}/customer-service-image.png`}
              className={styles.useCaseSmallImage}
              alt='Customers service'
            />
            <Flex
              vertical
              gap={12}
              align='start'
              justify='center'
              className={styles.useCaseTextWrapper}
            >
              <span className={styles.useCaseSmallImageTitle}>
                Customer service
              </span>
              <span className={styles.useCaseSmallImageDescription}>
                Text bots are boring. Give your customer service chat a real
                human like experience to enhance your customer visits
              </span>
            </Flex>
          </Flex>
          <Flex
            vertical
            gap={20}
            align='center'
            justify='center'
            className={styles.useCaseSmallImageContainer}
          >
            <img
              src={`${WEBSITE_PUBLIC_CDN}/game-npcs-image.png`}
              className={styles.useCaseSmallImage}
              alt='NPC'
            />
            <Flex
              vertical
              gap={12}
              align='start'
              justify='center'
              className={styles.useCaseTextWrapper}
            >
              <span className={styles.useCaseSmallImageTitle}>Game NPCs</span>
              <span className={styles.useCaseSmallImageDescription}>
                Embed on any web app or game with our custom enterprise
                integrations
              </span>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
      <ProductsButton
        type='primary'
        onClick={() =>
          openNewTab(
            'https://calendly.com/ozonetechnologies/free-consult-discovery'
          )
        }
      >
        GET A FREE CONSULT
      </ProductsButton>
    </Flex>
  );
}
